module.exports = __webpack_public_path__ + "img/don_miguel.b0d99252.png";